"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonWidgetV2HeaderDto = exports.CommonWidgetV2HeaderMoreDto = exports.CommonResponseItemReviewDto = exports.CommonResponseItemPositionDto = exports.CommonResponseItemCaptionDto = exports.CommonResponseItemBenefitDto = exports.CommonResponseItemActionDto = exports.CommonItemLogMetaDto = exports.EnClientLogObjectType = exports.CommonItemLogMetaPriceDto = exports.CommonItemLogMetaBadgeDto = exports.WidgetLogMeta = exports.WidgetMoreSchema = exports.CommonResponseItemPropertyDto = exports.CommonResponseItemPropertyCustomDto = exports.CommonResponseItemImageDto = void 0;
var zod_1 = require("zod");
/**
 * 스타일 타입 이넘
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/enums/common_shared_library_shared_library._internal_.EnCommonResponseItemPropertyType.html}
 * */
var EnCommonResponseItemPropertyType = zod_1.z.union([
    zod_1.z.literal('BADGE__BORDER_GRAY'),
    zod_1.z.literal('BADGE__BORDER_YACARE'),
    zod_1.z.literal('BADGE__BORDER_YAPINK'),
    zod_1.z.literal('BADGE__COUPON_PRICE'),
    zod_1.z.literal('BADGE__FILL_BLACK'),
    zod_1.z.literal('BADGE__FILL_BLUE'),
    zod_1.z.literal('BADGE__FILL_GRAY'),
    zod_1.z.literal('BADGE__HOT_DEAL'),
    zod_1.z.literal('BADGE__HOT_DEAL_DESCRIPTION'),
    zod_1.z.literal('BADGE__JTA_MARK'),
    zod_1.z.literal('BADGE__KQ_MARK'),
    zod_1.z.literal('BADGE__KTO_MARK'),
    zod_1.z.literal('BADGE__MEMBER_CLASS_FLIGHT_01'),
    zod_1.z.literal('BADGE__MEMBER_CLASS_LEVEL_01'),
    zod_1.z.literal('BADGE__PAIR_YAPINK'),
    zod_1.z.literal('IMAGE__INSTANT_DISCOUNT'),
    zod_1.z.literal('IMAGE__SPECIAL_DISCOUNT'),
    zod_1.z.literal('TEXT__CAPTION'),
    zod_1.z.literal('TEXT__CAPTION__REGULAR'),
    zod_1.z.literal('TEXT__CAPTION__STRIKE'),
    zod_1.z.literal('TEXT__CAPTION_BODY_1_REGULAR_GRAY_900'),
    zod_1.z.literal('TEXT__CHECK_OTHER_DATES'),
    zod_1.z.literal('TEXT__DAILY_BASIS'),
    zod_1.z.literal('TEXT__DAILY_PRICE'),
    zod_1.z.literal('TEXT__DATE_BASED_NORMAL_PRICES'),
    zod_1.z.literal('TEXT__DATE_BASED_NORMAL_PRICES__STRIKE'),
    zod_1.z.literal('TEXT__DATE_BASED_SALES_COMPLETED'),
    zod_1.z.literal('TEXT__DESCRIPTION'),
    zod_1.z.literal('TEXT__DOMESTIC_REVIEW_COUNT'),
    zod_1.z.literal('TEXT__DOMESTIC_REVIEW_DESCRIPTION__BOLD'),
    zod_1.z.literal('TEXT__DOMESTIC_REVIEW_DESCRIPTION__HIGHLIGHT'),
    zod_1.z.literal('TEXT__DOMESTIC_REVIEW_SCORE'),
    zod_1.z.literal('TEXT__EVENT_DISCOUNT_RATE'),
    zod_1.z.literal('TEXT__EVENT_SPECIAL_PRICE'),
    zod_1.z.literal('TEXT__EVENT_SPECIAL_PRICE__STRIKE'),
    zod_1.z.literal('TEXT__EVENT_SPECIAL_TYPE'),
    zod_1.z.literal('TEXT__FEATURE_BODY_1_REGULAR_GRAY_600'),
    zod_1.z.literal('TEXT__GLOBAL_REVIEW_COUNT'),
    zod_1.z.literal('TEXT__GLOBAL_REVIEW_SCORE'),
    zod_1.z.literal('TEXT__INFORMATION_LANDMARK'),
    zod_1.z.literal('TEXT__INFORMATION_LOCATION'),
    zod_1.z.literal('TEXT__INFORMATION_PROMOTION'),
    zod_1.z.literal('TEXT__INFORMATION_ROOM'),
    zod_1.z.literal('TEXT__LIST_PRICE'),
    zod_1.z.literal('TEXT__LIST_PRICE_DATE'),
    zod_1.z.literal('TEXT__LIST_PRICE_SALES_END'),
    zod_1.z.literal('TEXT__LIST_PRICE_UNIT'),
    zod_1.z.literal('TEXT__LOCATION'),
    zod_1.z.literal('TEXT__LOCATION_BODY_1_REGULAR_GRAY_600'),
    zod_1.z.literal('TEXT__LOCATION_DESCRIPTION'),
    zod_1.z.literal('TEXT__LOCATION_DESCRIPTION__FULL'),
    zod_1.z.literal('TEXT__NOTICE'),
    zod_1.z.literal('TEXT__POI_PRICE'),
    zod_1.z.literal('TEXT__POI_PRICE_DATE'),
    zod_1.z.literal('TEXT__POI_PRICE_UNIT'),
    zod_1.z.literal('TEXT__PRICE'),
    zod_1.z.literal('TEXT__PRICE_DATE'),
    zod_1.z.literal('TEXT__PRICE_INFO'),
    zod_1.z.literal('TEXT__PRICE_INFO__BAR'),
    zod_1.z.literal('TEXT__PRICE_INFO__PRICE_NOTE'),
    zod_1.z.literal('TEXT__PRICE_INFO__PRICE_NOTE__STRIKE'),
    zod_1.z.literal('TEXT__PRICE_UNIT'),
    zod_1.z.literal('TEXT__PRICE_UNIT__SMALL'),
    zod_1.z.literal('TEXT__RANKING'),
    zod_1.z.literal('TEXT__RESERVATION_CLOSED'),
    zod_1.z.literal('TEXT__SALE'),
    zod_1.z.literal('TEXT__SALE_POSTFIX'),
    zod_1.z.literal('TEXT__SALE_PREFIX'),
    zod_1.z.literal('TEXT__SALE_PREFIX__BAR'),
    zod_1.z.literal('TEXT__SALE_UNIT'),
    zod_1.z.literal('TEXT__SALES_COMPLETED'),
    zod_1.z.literal('TEXT__SPECIAL_PRICE'),
    zod_1.z.literal('TEXT__TITLE'),
    zod_1.z.literal('TEXT__TITLE__BOLD'),
    zod_1.z.literal('TEXT__TITLE__BOLD_GRAY'),
    zod_1.z.literal('TEXT__TITLE__GRAY'),
    zod_1.z.literal('TEXT__WIDGET_PRICE'),
    zod_1.z.literal('TEXT__WIDGET_PRICE_DATE'),
    zod_1.z.literal('TEXT__WIDGET_PRICE_UNIT'),
]);
/**
 * 비율/고정 여부
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/enums/common_shared_library_shared_library._internal_.EnImageUnitType.html}
 * */
var EnImageUnitType = zod_1.z.union([zod_1.z.literal('FIXED'), zod_1.z.literal('FLEXIBLE')]);
/** 이미지 영역 정보
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/common_shared_library_shared_library.CommonResponseItemImageDto.html}
 * */
exports.CommonResponseItemImageDto = zod_1.z.object({
    /** 높이 px */
    height: zod_1.z.number(),
    /** 이미지 링크 */
    url: zod_1.z.string(),
    /** 너비 px */
    width: zod_1.z.number(),
    /** 비율/고정 여부 */
    unit: EnImageUnitType,
});
/**
 * 커스텀 스타일 적용
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/common_shared_library_shared_library.CommonResponseItemPropertyCustomDto.html}
 * */
exports.CommonResponseItemPropertyCustomDto = zod_1.z.object({
    /**
     * 배경색
     * */
    backgroundColor: zod_1.z.string().nullable(),
    /**
     * 테두리색
     * */
    borderColor: zod_1.z.string().nullable(),
    /**
     * 텍스트 색깔
     * */
    fontColor: zod_1.z.string().nullable(),
    /**
     * 텍스트 스타일
     * */
    fontStyle: zod_1.z.string().nullable(),
    /** 취소선 유무 */
    isStrike: zod_1.z.boolean().nullable(),
    /**
     * 줄 제한
     * */
    numberOfLines: zod_1.z.number().nullable(),
    /**
     * 글자 뒤에 놓여질 이미지 정보
     * */
    postImage: exports.CommonResponseItemImageDto.nullable(),
    /**
     * 글자 앞에 놓여질 이미지 정보
     * */
    preImage: exports.CommonResponseItemImageDto.nullable(),
});
/**
 * 기본 공통 영역 정보
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/common_shared_library_shared_library.CommonResponseItemPropertyDto.html}
 * */
exports.CommonResponseItemPropertyDto = zod_1.z.object({
    /** 노출되는 값 */
    value: zod_1.z.string(),
    /** 스타일 타입 */
    type: EnCommonResponseItemPropertyType,
    /** 커스텀 스타일 적용*/
    custom: exports.CommonResponseItemPropertyCustomDto.nullable(),
});
exports.WidgetMoreSchema = zod_1.z.object({
    title: zod_1.z.string(),
    action: zod_1.z.object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    }),
    logMeta: zod_1.z.record(zod_1.z.unknown()),
});
exports.WidgetLogMeta = zod_1.z.object({
    objectContainer: zod_1.z.string(),
    widgetTitle: zod_1.z.string(),
    widgetTargetTitle: zod_1.z.string(),
});
exports.CommonItemLogMetaBadgeDto = zod_1.z.object({
    benefits: zod_1.z.array(zod_1.z.string()),
    categories: zod_1.z.array(zod_1.z.string()),
    discounts: zod_1.z.array(zod_1.z.string()),
});
exports.CommonItemLogMetaPriceDto = zod_1.z.object({
    discountPrices: zod_1.z.array(zod_1.z.nullable(zod_1.z.number())),
    discountRates: zod_1.z.array(zod_1.z.nullable(zod_1.z.number())),
    infoList: zod_1.z.array(zod_1.z.string()),
    originPrices: zod_1.z.array(zod_1.z.nullable(zod_1.z.number())),
    sellPrices: zod_1.z.array(zod_1.z.nullable(zod_1.z.number())),
});
exports.EnClientLogObjectType = zod_1.z.union([
    zod_1.z.literal('productCurationGridId'),
    zod_1.z.literal('productCurationGridGroupId'),
    zod_1.z.literal('productCurationSwipeId'),
    zod_1.z.literal('entertainmentId'),
    zod_1.z.literal('exhibitionId'),
    zod_1.z.literal('propertyId'),
    zod_1.z.literal('leisureTicketNo'),
    zod_1.z.literal('OBJECT_TYPE_PRODUCT_ID'),
    zod_1.z.literal('placeNo'),
    zod_1.z.literal('quickCategoryBoardRowItem'),
    zod_1.z.literal('regionChipName'),
    zod_1.z.literal('seeAllBtn'),
    zod_1.z.literal('tabBtn'),
]);
exports.CommonItemLogMetaDto = zod_1.z.record(zod_1.z.unknown());
/**
 * 클릭/터치 시 이동할 경로
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/common_shared_library_shared_library.CommonResponseItemActionDto.html}
 * */
exports.CommonResponseItemActionDto = zod_1.z.object({
    app: zod_1.z.string(),
    web: zod_1.z.string(),
});
/**
 * 기본 공통 영역 정보
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/common_shared_library_shared_library.CommonResponseItemBenefitDto.html}
 * */
exports.CommonResponseItemBenefitDto = zod_1.z.object({
    /** 커스텀 스타일 적용 */
    custom: exports.CommonResponseItemPropertyCustomDto.nullable(),
    /** 부가설명*/
    description: zod_1.z.string().nullable(),
    /** 스타일 타입 */
    type: EnCommonResponseItemPropertyType,
    /**
     * 노출되는 값
     * */
    value: zod_1.z.string(),
});
/** 카테고리/지역
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/common_shared_library_shared_library.CommonResponseItemCaptionDto.html}
 * */
exports.CommonResponseItemCaptionDto = zod_1.z.object({
    /**
     * 캡션 뒤 뱃지
     * */
    badge: exports.CommonResponseItemPropertyDto.nullable(),
    /**
     * 캡션명
     * */
    title: exports.CommonResponseItemPropertyDto,
});
/**
 * 상품 아이템의 위경도 정보
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/common_shared_library_shared_library.CommonResponseItemPositionDto.html}
 * */
exports.CommonResponseItemPositionDto = zod_1.z.object({
    /** 위도*/
    latitude: zod_1.z.number(),
    /** 경도 */
    longitude: zod_1.z.number(),
});
/**
 * 리뷰 영역 정보
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/common_shared_library_shared_library.CommonResponseItemReviewDto.html}
 * */
exports.CommonResponseItemReviewDto = zod_1.z.object({
    /** 아이템 리뷰 갯수 */
    count: exports.CommonResponseItemPropertyDto,
    /** 아이템 리뷰 설명 */
    description: exports.CommonResponseItemPropertyDto,
    /** 아이템 리뷰 점수 */
    score: exports.CommonResponseItemPropertyDto.nullable(),
    /** 리뷰 타입
     * TODO: enum으로 변경
     * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/enums/common_shared_library_shared_library._internal_.EnCommonResponseItemReviewType.html}
     * */
    type: zod_1.z.string(),
});
/**
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/common_cx_api_common_interface_common_interface.CommonWidgetV2HeaderMoreDto.html}
 */
exports.CommonWidgetV2HeaderMoreDto = zod_1.z.object({
    title: zod_1.z.string().nullish(),
    action: exports.CommonResponseItemActionDto.nullish(),
});
/**
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/common_cx_api_common_interface_common_interface.CommonWidgetV2HeaderDto.html#constructor.new_CommonWidgetV2HeaderDto.MORE-1}
 * */
exports.CommonWidgetV2HeaderDto = zod_1.z.object({
    icon: zod_1.z.string().nullish(),
    more: exports.CommonWidgetV2HeaderMoreDto.nullish(),
    subTitle: zod_1.z.string().nullable(),
    title: zod_1.z.string().nullable(),
});
